import type { AdminProcess } from './adminProcessDetailsTypes';
import { ServiceType } from '../../../../common/enums/serviceType';
import { translateKey } from '../../../translate';
import { FormDivider, FormParagraph } from '../../elements/common';
import { FormLabel } from '../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../elements/forms/InputContainer';
import { loadAdminDetailsCustomControl } from '../customControls/loadAdminDetailsCustomControl';

interface IAdminProcessDetailsCustomControlsProps {
    adminProcess: AdminProcess;
    reload: () => Promise<void>;
}

export function AdminProcessDetailsCustomControls(props: IAdminProcessDetailsCustomControlsProps) {
    const CustomControl = loadAdminDetailsCustomControl(
        props.adminProcess.customControlVersion,
        props.adminProcess.service.code
    );

    if (CustomControl) {
        return (
            <>
                <CustomControl
                    {...props.adminProcess}
                    reload={props.reload}
                />
                <FormDivider />
            </>
        );
    }

    if (props.adminProcess.service.serviceType === ServiceType.invitation) {
        return null;
    }

    return (
        <>
            <HorizontalFormGroupRead>
                <FormLabel>{translateKey('processDetails.attachments')}</FormLabel>
                <InputContainer>
                    <FormParagraph>{getAssetCount()}</FormParagraph>
                </InputContainer>
            </HorizontalFormGroupRead>

            <FormDivider />
        </>
    );

    function getAssetCount() {
        let assetCounter = 0;
        if (props.adminProcess.assets) {
            assetCounter += props.adminProcess.assets.length;
        }

        if (props.adminProcess.customControlData && props.adminProcess.customControlData.files) {
            assetCounter += props.adminProcess.customControlData.files.length;
        }

        if (props.adminProcess.procedure) {
            if (props.adminProcess.procedure.assets) {
                assetCounter += props.adminProcess.procedure.assets.length;
            }

            if (
                props.adminProcess.procedure.customControlData &&
                props.adminProcess.procedure.customControlData.files
            ) {
                assetCounter += props.adminProcess.procedure.customControlData.files.length;
            }
        }

        return assetCounter;
    }
}
